export default __webpack_public_path__ + "static/media/logo.7ec64f8a.svg";